import { Image } from "@heroui/react";
import { getStaticAsset } from "core/model/config";
import { useExternalLinkLabel } from "ds_legacy/components/LinkV2";
import { getRecareLogoWithNamePath } from "ds_legacy/components/RecareLogo";
import { Link } from "ds/ui";
import { useTranslations } from "translations";

type AdmissionsFooterProps = {
  privacyURL?: string;
};

export function AdmissionsFooter({ privacyURL }: AdmissionsFooterProps) {
  const externalLinkLabel = useExternalLinkLabel();
  const translations = useTranslations();
  return (
    <footer className="flex flex-col items-center gap-4 font-lexend">
      {privacyURL && (
        <Link
          aria-label={externalLinkLabel(
            translations.careproviderApp.recareAdmissionsForm.linkPrivacyPolicy,
          )}
          className="text-xs leading-6 font-medium text-primary"
          color="primary"
          href={privacyURL}
          id="admissions-privacy-policy"
          isExternal
        >
          {translations.careproviderApp.recareAdmissionsForm.linkPrivacyPolicy}
        </Link>
      )}
      <div className="flex w-full items-center justify-center gap-1 bg-[#070A25] py-3">
        <span className="text-sm font-light text-white">
          {translations.careproviderApp.recareAdmissionsForm.footerPoweredBy}
        </span>
        <Image
          alt={
            translations.careproviderApp.recareAdmissionsForm.altTextLogoRecare
          }
          height={48}
          src={getStaticAsset(getRecareLogoWithNamePath("yellow"))}
          width={120}
        />
      </div>
    </footer>
  );
}
